import React from "react";
import { ContentService, NumberService, Service } from "./style";

export const ServiceCard = ({ service }) => {
  const { number, title, description, services } = service;
  return (
    <Service>
      <NumberService>
        <h2>0{number}</h2>
        <h3>{title}</h3>
      </NumberService>
      <ContentService>
        <p>{description}</p>
        <span>{services}</span>
      </ContentService>
    </Service>
  );
};
